
document.addEventListener("DOMContentLoaded", () => {

    const scannerInput = document.getElementById('scanner');
    if(scannerInput) {
        scannerInput.addEventListener('keypress', (event) => {
            if(event.code === 'Enter') {
                event.preventDefault();
                Livewire.emit('scannerInput', event.target.value);
            }
        })
    }
    const unprintedCheckbox = document.getElementById('unprinted');
    if(unprintedCheckbox) {
        unprintedCheckbox.addEventListener('change', (event) => {
            if(event.target.checked) {
                Livewire.emit('laraveltable:refresh', {unPrintedOnly: 1});
            } else {
                Livewire.emit('laraveltable:refresh', {unPrintedOnly: 0});
            }
        })
    }
});

Livewire.on('tabelLaetud', postId => {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
    let tfoot = document.querySelector('tfoot.table-light div.p-2 div');
    let buttons = '' +
        '<div style="margin-bottom: 20px">' +
        '<a id="createLabels" class="btn btn-primary" href="https://saadetised.nordic-digital.ee/shipments/createlabels?ids=">Koosta pakisildid</a>' +
        '<a id="deleteLabels" class="btn btn-danger" href="https://saadetised.nordic-digital.ee/shipments/delete?ids=" style="margin-left: 50px;">Kustuta valitud saadetised</a>' +
        '</div>';
    tfoot.innerHTML = buttons + tfoot.innerHTML;
    const dd = document.getElementsByClassName('shipment');

    const checkboxCell = document.querySelector('th[wire\\:key="column-checkbox"]');
    checkboxCell.innerHTML = '<input type="checkbox" id="selectAll" />';

    const selectAll = document.getElementById('selectAll');
    selectAll.addEventListener('change', (e) => {
        const shipmentList = document.querySelectorAll("input[class='shipment']");
        const changeEvent = new Event("change");
        Array.from(shipmentList).forEach(element => {
            element.checked = e.target.checked;
            element.dispatchEvent(changeEvent);
        });
    });


    Array.from(dd).forEach(element => {
        element.addEventListener('change', () => {
            let ids = [];
            const checkedList = document.querySelectorAll("input[class='shipment']:checked");
            Array.from(checkedList).forEach(element => {
                ids.push(element.value);
            });
            let createLabelsUrl = labelsUrl + ids.join(',');
            let deleteShipmentsUrl = deleteUrl + ids.join(',');
            document.getElementById('createLabels').href = createLabelsUrl;
            document.getElementById('deleteLabels').href = deleteShipmentsUrl;
        });
    });
})



